var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _circle, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _line, _line2, _circle2, _circle3, _ellipse7, _ellipse8, _path4, _ellipse9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#B5651D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 200,
    ry: 80,
    fill: "#A27E45"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 80,
    rx: 150,
    ry: 60,
    fill: "#8C6D3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 L100,200 L150,230 L200,200 L250,230 L300,200 L350,230 L400,200",
    fill: "none",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200,220 C260,210 310,210 350,220 L350,250 C290,245 240,245 200,250 Z",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200,220 C190,200 200,180 220,180 C240,180 250,200 240,220",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 180,
    r: 60,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 45,
    ry: 36,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 32,
    ry: 25,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 20,
    ry: 16,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 185,
    x2: 200,
    y2: 160,
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 185,
    x2: 240,
    y2: 160,
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 8,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 8,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 160,
    rx: 3,
    ry: 4,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 160,
    rx: 3,
    ry: 4,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210,210 C215,215 225,215 230,210",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 250,
    rx: 70,
    ry: 10,
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail6);
export default __webpack_public_path__ + "static/media/funny-snail6.26f91bbbf15224603db257be9e7d3fd7.svg";
export { ForwardRef as ReactComponent };